// Clasificar (o devolver a «sin clasificar») una captura rápida desde la web.
//
// Son MUTACIONES que invalidan el registro de terreno: la captura cambia de
// sección, el contador de la barra de pestañas y el índice lateral con ella, y
// todo eso sale de la misma consulta.

import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  clasificarCaptura,
  devolverCapturaASinClasificar,
  type DestinoDeCaptura,
} from "@/lib/terreno";

import { registroDeTerrenoKey } from "./useRegistroDeTerreno";

export function useClasificarCaptura(informeId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ uuid, ...destino }: { uuid: string } & DestinoDeCaptura) =>
      clasificarCaptura(informeId, uuid, destino),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: registroDeTerrenoKey(informeId) }),
  });
}

export function useDevolverCapturaASinClasificar(informeId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (uuid: string) => devolverCapturaASinClasificar(informeId, uuid),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: registroDeTerrenoKey(informeId) }),
  });
}
